import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/auth-context'
import { Loader2 } from 'lucide-react'

interface PrivateRouteProps {
    children: React.ReactNode
    allowedRoles?: ('student' | 'mentor' | 'admin' | 'sub-admin' | 'counsellor')[]
}

export function PrivateRoute({ children, allowedRoles }: PrivateRouteProps) {
    const { isAuthenticated, isLoading, user } = useAuth()
    const location = useLocation()

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
                <Loader2 className="h-8 w-8 text-primary-blue animate-spin" />
            </div>
        )
    }

    if (!isAuthenticated) {
        // Redirect to login page, but save the current location they were trying to go to
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (allowedRoles && user && !allowedRoles.includes(user.role)) {
        // Role-based access control
        if (user.role === 'student') {
            return <Navigate to="/dashboard" replace />
        }
        if (user.role === 'mentor') {
            return <Navigate to="/mentor/dashboard" replace />
        }
        if (user.role === 'admin') {
            return <Navigate to="/admin/dashboard" replace />
        }
        if (user.role === 'sub-admin') {
            return <Navigate to="/sub-admin/dashboard" replace />
        }
        if (user.role === 'counsellor') {
            return <Navigate to="/counsellor/dashboard" replace />
        }
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}
